<!--
 * @Author: likk
 * @Date: 2023-09-05 17:52:53
 * @LastEditTime: 2024-03-29 05:09:05
 * @LastEditors: likk 1126919170@qq.com
 * @Description: 作业服务信息
-->
<template>
  <el-main class="business-area">
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <el-form ref="filterForm" :inline="true" :model="filterForm" class="filter-form" v-collapseAndexpand>
        <el-form-item prop="checkedRegion">
          <el-cascader
            ref="regionCascader"
            :props="regionProps"
            v-model="filterForm.checkedRegion"
            placeholder="所在地区"
            @change="handleRegionChange('regionCascader')"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="ownerName">
          <el-input  v-model="filterForm.ownerName" placeholder="服务方名称"  clearable></el-input>
        </el-form-item>
        <el-form-item prop="checkedWorkType">
          <el-cascader :options="workTypeList" :props="props" v-model="filterForm.checkedWorkType" clearable placeholder="作业类型"></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" style="width: 100%" v-loading="loading" tooltip-effect="custom-tooltip-style">
        <el-table-column fixed="left" label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ (pagination.pageNum - 1) * pagination.pageSize + (scope.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column
          label="服务照片"
          min-width="100"
          align="center"
        >
        <template slot-scope="{row}">
          <img class="thumb" :src="row.serviceThumb"/>
        </template>
        </el-table-column>
        <el-table-column
          prop="ownerName"
          label="服务方名称"
          min-width="120"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="workTypeNames"
          label="作业类型"
          min-width="120"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="workAreaNames"
          label="作业区域"
          min-width="150"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="所在地区"
          min-width="160"
          align="center"
        >
        <template slot-scope="{row}">
            {{ row.workProvinceName }} {{ row.workCityName }} {{ row.workCountyName }}
        </template>
        </el-table-column>
        <el-table-column
          prop="auditStatusName"
          label="状态"
          min-width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180" align="center">
          <template slot-scope="{row}">
            <el-button type="text"  @click="handleDetail(row.id)">查看</el-button>
            <el-button type="text"  @click="handleEdit(row.id)">修改</el-button>
            <el-button type="text"  @click="handleDelete(row.id)">删除</el-button>
            <el-button v-if="row.auditStatus=='10'" type="text"  @click="handleAudit(row.id)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :current-page="pagination.pageNum"
        :hide-on-single-page="true"
        @current-change="handleFilter"
      >
      </el-pagination>
    </div>
    
  </el-main>
</template>

<script>
import { workServiceList,workTypeTree,workServiceDelete } from "@/api/gxInfo"
export default {
  data() {
    return {
      filterForm: {
        auditStatus:20,
        ownerName: "",
        checkedWorkType: [],
        checkedRegion:[],
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [], // 表格数据
      workTypeList:[],
      props:{
        label:'name',
        value:'code',
      },
      regionProps: {
        lazy: true,
        lazyLoad: this.lazyLoad,
        expandTrigger: "hover",
        value: "i",
        label: "n",
        checkStrictly: true
      },
      loading:false
    };
  },
  watch: {
    ["filterForm.checkedRegion"]:{
      handler(val) {
        (!val) && (this.filterForm.checkedRegion=[]);
      }
    }
  },
  created() {
    this.handleFilter();
    this.getWorkTypes();
  },
  methods: {
    /**
     * @Author: likk
     * @description: 获取作业类型数据
     * @param {*}
     * @return {*}
     */   
    async getWorkTypes(){
      const { data } = await workTypeTree();
      this.workTypeList = data.result || [];
    },
    /**
     * @Author: likk
     * @description: 获取作业需求列表
     * @param {*}
     * @return {*}
     */ 
     async getList(){
      try {
        this.loading = true;
        let { checkedWorkType, checkedRegion, ...params } = this.filterForm;
        let { data: {content,recordTotal} } = await workServiceList({
          ...params,
          workType:checkedWorkType[checkedWorkType.length-1],
          workProvinceId: checkedRegion[0] || "",
          workCityId: checkedRegion[1] || "",
          workCountyId: checkedRegion[2] || "",
          currentPage:this.pagination.pageNum,
          pageSize:this.pagination.pageSize,
        });
        this.tableData = content;
        this.pagination.total = recordTotal;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },  
    /* @description: 异步加载地区数据
     * @Author: likk
     * @Date: 2023-08-02 14:19:56
     * @param {*} level
     * @param {*} value
     * @param {*} resolve
     * @return {*}
     */
    async lazyLoad({ level, value }, resolve) {
      let dataSource = [];
      if (level === 0) {
        dataSource = await this.getChildRegion(1);
      } else {
        dataSource = await this.getChildRegion(value);
      }
      resolve(
        dataSource.map((item) => ({
          ...item,
          leaf: level >= 2,
        }))
      );
    },
     /**
     * @description: 根据父id查询省市县乡村子地区
     * @Author: likk
     * @Date: 2023-08-02 15:35:57
     * @return {*}
     */
     async getChildRegion(pid) {
      const { data } = await this.$http.common.getChildRegion({ pid });
      return data || [];
    },
    handleRegionChange(refName){
      this.$refs[refName].dropDownVisible = false
    },
    
    /**
     * @Author: likk
     * @description: 查询
     * @param {Number} page 页码
     * @return {*}
     */  
    handleFilter(page=1){
      this.pagination.pageNum = page;
      this.getList();
    }, 
    /**
      * @Author: likk
      * @description: 查看
      * @param {*}
      * @return {*}
    */    
    handleDetail(id){
      this.$router.push({
        path:'/gx-query/service/detail',
        query: {id}
      })
    },
    handleAudit(id){
      this.$router.push({
        path:'/gx-query/service/audit',
        query: {id}
      })
    },
    handleEdit(id){
      this.$router.push({
        path:'/gx-query/service/edit',
        query: {id}
      })
    },
    handleDelete(id){
      this.$confirm("确认要删除该数据吗？", "", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        workServiceDelete(id).then( () => {
          this.$message({ type: 'success',  message: '删除成功' });
          this.handleFilter();
        });
      })
    }
   
  },
};
</script>
<style lang="scss" scoped>
  .el-table{
    .thumb{
      height: 50px;
    }
  }
</style>
<style lang="scss">
  .el-tooltip__popper.is-custom-tooltip-style{
    background: #303133;
    color: #FFFFFF;
    max-width: 95vw;
    // display: -webkit-box;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // -webkit-line-clamp: 10;
    // -webkit-box-orient: vertical;
    // &:before{
    //   height: 10px;
    //   background: #303133;
    //   content:"";
    //   position: absolute;
    //   left: 0;
    //   right: 0;
    //   bottom: 0;
    // }
  }
</style>
